// extracted by mini-css-extract-plugin
export default {"imgWrapper":"S0hb17ir","desktop":"desktop"};